var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 0.5C6.57913 0.5 7.90177 1.04786 8.87696 2.02304C9.85215 2.99823 10.4 4.32087 10.4 5.7C10.4 6.988 9.928 8.172 9.152 9.084L9.368 9.3H10L14 13.3L12.8 14.5L8.8 10.5V9.868L8.584 9.652C7.672 10.428 6.488 10.9 5.2 10.9C3.82087 10.9 2.49823 10.3521 1.52304 9.37696C0.547855 8.40177 0 7.07913 0 5.7C0 4.32087 0.547855 2.99823 1.52304 2.02304C2.49823 1.04786 3.82087 0.5 5.2 0.5ZM5.2 2.1C3.2 2.1 1.6 3.7 1.6 5.7C1.6 7.7 3.2 9.3 5.2 9.3C7.2 9.3 8.8 7.7 8.8 5.7C8.8 3.7 7.2 2.1 5.2 2.1Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.be9d95380834c89a8003c4034900db75.svg";
export { ForwardRef as ReactComponent };